import { Button, HoverCard } from '@mantine/core';
import { FC } from 'react';

import NullComponent from '@/components/NullComponent.tsx';
import Paragraph from '@/components/text/Paragraph.tsx';

import useConfig from '@/hooks/useConfig.ts';

import { pvs_provider_names } from '@/models/customers/PVSProvider.ts';

import { usePrismicConfigStore } from '@/stores/prismicConfigStore.ts';

const InstanceLegend: FC = () => {
    const { configs } = useConfig();
    const instance_colors = usePrismicConfigStore((state) => state.instance_colors);

    if (configs.length <= 1) return <NullComponent />;

    return (
        <HoverCard>
            <HoverCard.Target>
                <Button
                    className="color-slate-700 color-slate-500 cursor-default border-slate-300 dark:text-neutral-300 dark:hover:text-neutral-200"
                    variant="outline"
                >
                    {`${configs.length} ${configs.length === 1 ? 'Instanz' : 'Instanzen'}`}
                </Button>
            </HoverCard.Target>
            <HoverCard.Dropdown>
                {configs.map((config) => (
                    <div key={`${config.instance_id}-legend`} className="flex items-center gap-2">
                        <div
                            style={{ backgroundColor: instance_colors[config.instance_id] }}
                            className="size-4 rounded-md"
                        />
                        <Paragraph>{pvs_provider_names[config.pvs_provider]}</Paragraph>
                    </div>
                ))}
            </HoverCard.Dropdown>
        </HoverCard>
    );
};

export default InstanceLegend;
